import { FC } from 'react';
import { EuiLoadingChart } from '@elastic/eui';

export type Props = {
  show: boolean;
};

const SpinnerEmbed: FC<Props> = ({ show }) => {
  if (!show) return <></>;

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 99,
      }}>
      <EuiLoadingChart mono size="xl" />
    </div>
  );
};

export default SpinnerEmbed;
